import { identify, Identify, init, track } from '@amplitude/analytics-node';
import { SECOND } from 'core/common/constants';
import { CookiesService } from 'core/common/services/cookie';
import { generateUUID } from 'core/common/utils/generateUUID';
import {
  AnalyticsEventProperties,
  AmplitudeEventUserProperty,
  AnalyticsEventValue,
  ExtendedAnalyticsEventValue,
  isExtendedAnalyticsEvent,
} from '../../entities';
import { AmplitudeService } from '../../interfaces';

export class AmplitudeServerService implements AmplitudeService {
  private deviceId?: string;
  private readonly deviceIdCookieName = 'device_id';

  constructor(
    apiKey: string,
    private readonly cookiesService: CookiesService,
  ) {
    init(apiKey, {
      flushIntervalMillis: SECOND,
      flushQueueSize: 10,
    });

    this.deviceId = this.setDeviceId();
  }

  private setDeviceId(): string {
    const deviceId = this.cookiesService.get(this.deviceIdCookieName);

    if (!deviceId) {
      const newDeviceId = generateUUID();

      this.cookiesService.set(this.deviceIdCookieName, newDeviceId, { path: '/' });

      return newDeviceId;
    }

    return deviceId;
  }

  logEvent(eventName: string, properties?: AnalyticsEventProperties): void {
    track(eventName, properties, {
      device_id: this.deviceId,
    });
  }

  trackEvent(event: AnalyticsEventValue, properties?: AnalyticsEventProperties): void {
    if (isExtendedAnalyticsEvent(event)) {
      this.trackExtendedEvent(event, properties);
      return;
    }

    this.logEvent(event, properties);
  }

  private trackExtendedEvent(
    event: ExtendedAnalyticsEventValue,
    properties?: AnalyticsEventProperties,
  ): void {
    this.logEvent(event.name, { ...event.properties, ...properties });
  }

  setUserProperties(userData: Record<string, AmplitudeEventUserProperty>): void {
    const identifyObj = new Identify();

    Object.entries(userData).forEach(([key, value]) => {
      identifyObj.set(key, value);
    });

    identify(identifyObj, { device_id: this.deviceId });
  }

  setFunnelProperties(): void {
    return;
  }

  setUtmTags(): void {
    return;
  }
  getDeviceId(): string {
    return '';
  }
  getSessionId(): string {
    return '';
  }

  setUserId(): void {
    return;
  }
  setUserEmail(): void {
    return;
  }
  setUserIdProperty(): void {
    return;
  }
  techPageOpened(): void {
    return;
  }
  trackPaymentFormState(): void {
    return;
  }
  paymentFormCompleted(): void {
    return;
  }
  paymentRetryScreenOpened(): void {
    return;
  }
  paymentRetryTryAgainClicked(): void {
    return;
  }
  paymentRetryCloseClicked(): void {
    return;
  }
  setUserAge(): void {
    return;
  }
  setFeatureFlagsAttributes(): void {
    return;
  }
}
